<template>
  <div>
    <button v-for="(b,bi) in list1" :key="bi + 'list1'"
     class="btn btn-xs"
     :class="(b.missing ? 'pk-slide-missing' : '') + (activeViewGroup !== 1 && b.slide === activeSlide ? ' active' : '')"
     v-on:click="selectSimpleButton(b)">{{b.title}}</button>
    <!--<div style="margin-left:20px"></div>-->
    <button v-for="(b,i) in list2" :key="i + 'list2'"
     class="btn btn-xs"
     :class="(b.missing ? 'pk-slide-missing' : '') + (activeViewGroup !== 1 && b.slide === activeSlide ? ' active' : '')"
     v-on:click="selectSimpleButton(b)">{{b.title}}</button>
    <div style="margin-left:20px"></div>
    <button v-for="(b,j) in list3" :key="j + 'list3'"
     class="btn btn-xs"
     :class="(b.missing ? 'pk-slide-missing' : '') + (activeViewGroup !== 1 && b.slide === activeSlide ? ' active' : '')"
     v-on:click="selectTenButton(b)">{{b.title}}</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
export default Vue.extend({
  props: {
    navList: Array
  },
  data() {
    return {
      selectedNum: -1,
      selectedTen: 10,
      selectedNav: null,
    };
  },
  watch: {
  },
  methods: {
    selectSimpleButton(b) {
      if (b.missing) {
        return;
      }
      this.navList.forEach(a => a.selected = false);
      const i = b.idx;
      if (i % 10 === 0) {
        this.selectedTen = i;
      }
      this.selectedNum = i;
      this.$routerUpdateQuery(this, {
        sid: b.slide._id,
        view: 's-objectview',
        thumbnail: 0
      });
    },
    selectTenButton(b) {
      this.selectedTen = b.idx;
      this.selectSimpleButton(b);
    },
  },
  computed: {
    activeViewGroup() {
      return this.$store.getters['archive/activeViewGroup'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
    list1() {
      const s = this.selectedTen;
      return this.navList.filter((a) => {
        const i = a.idx;
        if (i < 10) {
          return true;
        }

      });
    },
    list2() {
      const s = this.selectedTen;
      return this.navList.filter((a) => {
        const i = a.idx;
        if (i >= s && i < (s + 10)) {
          return true;
        }
        return i < s && (i) % 10 === 0;
      });
    },
    list3() {
      const s = this.selectedTen;
      return this.navList.filter((a) => {
        const i = a.idx;
        return i > s && (i) % 10 === 0;
      });
    }
  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

button {
  @extend .pk-flex__vh-center;
  margin-right: 2px;
  width: 25px;
  height: 25px;
  background-color: #aaa;
  color: #fff;
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1;
  border-radius: 3px;
}

button.pk-slide-missing {
  opacity: 0.4;
  cursor: default;
  &:hover {
    color: #fff;
  }
}

button.active {
  background-color: #5a83bb;
  color: #fff;
}

.btn:focus {
  box-shadow: none;
}

</style>